const state = {
  selectFirstArray: [],
  selectSecondArray: [],
  selectThirdArray: [],
  currentFirstIndex: -1,
  currentSecondIndex: -1,
  currentThirdIndex: -1,
}

const mutations = {
  CHANGE_SELECTFIRST: (state, data) => {
    state.selectFirstArray = data.array
    state.currentFirstIndex = data.index
  },
  CHANGE_SELECTSECOND: (state, data) => {
    state.selectSecondArray = data.array
    state.currentSecondIndex = data.index
  },
  CHANGE_SELECTTHIRD: (state, data) => {
    state.selectThirdArray = data.array
    state.currentThirdIndex = data.index
  }
}

const actions = {
  setDisableSelect({dispatch, commit, state}, data) {
    // console.log('click', data)
    let currentIndex = state['current' + data.use + 'Index'],
      codeArray = state['select' + data.use + 'Array']
    if (!data.code) {
      currentIndex = -1
    } else {
      currentIndex = codeArray.findIndex(item => {
        return item == data.code
      })
    }
    commit('CHANGE_SELECT' + data.use.toUpperCase(), {array: codeArray, index: currentIndex})
  },
  disabledSelect({dispatch, commit, state}, data) {
    let currentIndex = state['current' + data.use + 'Index'],
      codeArray = state['select' + data.use + 'Array']
    if (currentIndex == -1) {
      let index = codeArray.findIndex(item => {
        return item == data.code
      })
      if (index == -1) {
        codeArray.push(data.code)
      } else {
        codeArray.splice(index, 1, data.code)
      }
    } else {
      codeArray.splice(currentIndex, 1, data.code)
    }
    commit('CHANGE_SELECT' + data.use.toUpperCase(), {array: codeArray, index: currentIndex})
  },
  deleteDisable({dispatch, commit, state}, data) {
    let currentIndex = state['current' + data.use + 'Index'],
      codeArray = state['select' + data.use + 'Array']
    if (currentIndex != -1 || data.code) {
      codeArray.splice(currentIndex, 1)
      commit('CHANGE_SELECT' + data.use.toUpperCase(), {array: codeArray, index: currentIndex})
    }
  },
  initSelect({dispatch, commit, state}, data) {
    commit('CHANGE_SELECT' + data.use.toUpperCase(), {array: [], index: -1})
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/disableSelectTree.js